module.exports = __webpack_public_path__ + "img/banner-referal.a6abb193.svg";